<div class="wrapper fadeInDown">
	<div id="formContent">

		<form autocomplete="off" [formGroup]="registerForm" (ngSubmit)="onSubmit(registerForm.value)">


			<div class="form-group">
				<input type="email" formControlName="email" class="formControl" id="exampleInputEmail1" placeholder="Email" autocomplete="username email"  required>
				<span class="text-danger"
					*ngIf="(registerFormControl.email.touched || submitted) && registerFormControl.email.errors?.required">
					Introduzca email
				</span>
				<span class="text-danger"
					*ngIf="registerFormControl.email.touched && registerFormControl.email.errors?.email">
					Introduzca un email correcto
				</span>
			</div>
			<div class="form-group">
				<input type="text" formControlName="telefono" class="formControl"  aria-describedby="telefonoHelp" placeholder="Teléfono" autocomplete="telefono"  required>
			</div>
			<div class="formGroup">
				<input type="password" formControlName="password" class="formControl" placeholder="Contraseña" autocomplete="new-password" #userPassword required>
				<span class="text-danger"
					*ngIf="(registerFormControl.password.touched || submitted) && registerFormControl.password.errors?.required">
					La contraseña es necesaria
				</span>
				<span class="text-danger"
					*ngIf="registerFormControl.password.touched && registerFormControl.password.errors?.invalidPassword">
					La constraseña debe tener como mínimo 8 caracteres letra mayuscula letra minuscula y numeros
				
				</span>
			</div>

			<div class="formGroup">
				<input type="password" formControlName="confirmPassword" class="formControl" placeholder="Confirmar contraseña" autocomplete="new-password" #userPassword required>
				<span class="text-danger"
					*ngIf="(registerFormControl.confirmPassword.touched || submitted)&& registerFormControl.confirmPassword.errors?.required">
					Es necesario confirmar contraseña
				</span>
				<span class="text-danger"
					*ngIf="registerFormControl.confirmPassword.touched && registerFormControl.confirmPassword.errors?.passwordMismatch">
					Las contraseñas no coinciden
				</span>
			</div>

			<div class="formGroup">
				<div class="form-group">
					<input type="email" formControlName="email2" class="formControl" id="exampleInputEmail1"
						aria-describedby="emailHelp" placeholder="Email administrador@" required>
				</div>
				<div class="tooltip-wrap">
					<i class="far fa-question-circle"></i>
					<div class="tooltip-content">
						<p>Introduzca email jefa/jefe del servicio FRIAT</p>
					</div>
				</div>
			</div>



			<!-- Calling SignIn Api from AuthService -->
			<div class="formGroup">
				<input type="submit" id="button" class="btn btnPrimary" value="Acceder">
			</div>
		</form>


		<div id="formFooter">
			<div class="redirectToLogin">
				<span>¿Ya tienes una cuenta? </span><a class="underlineHover" routerLink="/sign-in">Acceder</a>
			</div>
		</div>


	</div>


</div>

<app-index></app-index>